<template>
  <section class="section-padding">
    <div class="row">
      <div class="col-12 text-center">
        <template v-if="errorMessage && !paymentSuccess">
          <i class="fal fa-times-circle fa-5x text-danger"></i>
          <h4 class="mt-4">{{ $t('message.payment_method.payment_failure') }}: {{ errorMessage }}</h4>
          <div class="mt-4">
            <router-link class="btn btn-info btn-lg"
                         :to="{name: 'Service Request Detail', params: {id: serviceRequestId}}">
              {{ $t('message.booking.navigation.back') }}
            </router-link>
          </div>
        </template>
        <template v-else>
          <div>
            <i class="fal fa-check-circle fa-5x text-success"></i>
            <h3 class="mt-4">
              {{ $t('message.payment_method.payment_success') }}
            </h3>
            <div class="mt-3" v-if="paymentSuccess">
              <router-link class="btn btn-info btn-lg"
                           :to="{name: 'Service Request Detail', params: {id: serviceRequestId}}">
                {{ $t('message.booking.complete_step.view_my_booking') }}
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'PaymentServiceRequestValidation',
    data () {
      return {
        errorMessage: null,
        serviceRequestId: null,
        paymentSuccess: false
      }
    },
    watch: {
      payment () {
        if (this.payment) {
          // Clear payment data
          this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
          this.$store.commit('payment/SET_TMP_OMISE_TOKEN', null)

          // Prepare submit data
          const submitData = {...this.tmpConfirmPaymentData}
          submitData.omise_customer_id = this.payment.omise_customer_id
          submitData.user_id = this.user.id
          this.submitConfirmPrice(submitData)
        }
      }
    },
    computed: {
      ...mapGetters({
        payment: 'payment/getPayment',
        user: 'auth/getUser',
        globalState: 'globalVal/getState'
      }),
      ...mapState({
        tmpOmiseToken: state => state.payment.tmpOmiseToken,
        tmpIsDefaultCard: state => state.payment.tmpIsDefaultCard,
        tmpConfirmPaymentData: state => state.serviceRequest.tmpConfirmPaymentData
      })
    },
    methods: {
      async submitConfirmPrice (submitData) {
        this.serviceRequestId = submitData.service_request_id
        this.paymentSuccess = false

        // ทำรายการ service request จาก temp data ที่บันทึกไว้ใน ModalConfirmCost
        let {data} = await axios.post(this.globalState.customerApiUrl + '/service-requests/' + submitData.service_request_id + '/payment', submitData)
        if (!data.error) {
          this.paymentSuccess = true
          this.$store.commit('serviceRequest/SET_TMP_PAYMENT_CONFIRM_DATA', null)
        } else {
          this.errorMessage = data.message
          this.$swal({
            text: 'ผิดพลาด ' + data.message,
            type: 'error'
          })
        }
      }
    },
    async mounted () {
      if (this.tmpOmiseToken) {
        // Add new card
        const submitData = {
          user_id: this.user.id,
          omise_token: this.tmpOmiseToken,
          is_default: this.tmpIsDefaultCard
        }
        await this.$store.dispatch('payment/ADD_PAYMENT', submitData)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/payment/PaymentServiceRequestValidation.vue